"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BrowserInput = exports.BrowserButton = undefined;

var _react = require("react");

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var __assign = undefined && undefined.__assign || Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
    }
    return t;
};
var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
var BrowserButton = exports.BrowserButton = function BrowserButton(_a) {
    var _ = _a.loading,
        props = __rest(_a, ["loading"]);
    return React.createElement("button", __assign({}, props));
};
var BrowserInput = exports.BrowserInput = function BrowserInput(_a) {
    var _ = _a.error,
        _onChange = _a.onChange,
        label = _a.label,
        divProps = _a.divProps,
        labelProps = _a.labelProps,
        labelSpanProps = _a.labelSpanProps,
        props = __rest(_a, ["error", "onChange", "label", "divProps", "labelProps", "labelSpanProps"]);

    return React.createElement("div", __assign({}, divProps), label ? React.createElement("label", __assign({}, labelProps), React.createElement("span", __assign({}, labelSpanProps), label), React.createElement("input", __assign({}, props, { onChange: function onChange(e) {
            return _onChange(e.target[props.type === 'checkbox' ? 'checked' : 'value']);
        } }))) : React.createElement("input", __assign({}, props, { onChange: function onChange(e) {
            return _onChange(e.target[props.type === 'checkbox' ? 'checked' : 'value']);
        } })));
};
//# sourceMappingURL=browser-components.js.map



/*****************
 ** WEBPACK FOOTER
 ** ./dist/src/browser-components.js
 ** module id = 276
 ** module chunks = 0
 **/